import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { CampaignModel } from '../models/campaign';

@Injectable({
  providedIn: 'root'
})
export class CampaignProvider {

  page = 1;
  getPaginationCount;
  campaigns: CampaignModel[] = [];
  selectCampaigns: CampaignModel[] = [];
  //   rewardSubCategories: RewardSubCategoryModel[] = [];
  //   rewardParentCategories = [];
  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration
  ) {
  }

  getCampaignCount(): void {
    this.apiService.getHeaders(this.apiConfig.getAllCampaign).subscribe(
      (res: any) => {
        this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
        console.log('here', this.getPaginationCount);
        this.campaigns = res.body.data as CampaignModel[];
      }
    );

  }

  getCampaignList(): void {
    this.apiService.getHeaders(this.apiConfig.getAllCampaign + '?page=' + this.page).subscribe(
      (res: any) => {
        console.log('called');
        this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
        this.campaigns = res.data as CampaignModel[];
      }
    );
  }

  getAllCampaigns(): void {
    this.apiService.get(this.apiConfig.getAllCampaign).subscribe(
      (res: any) => {
        console.log('called');
        this.selectCampaigns = res.data as CampaignModel[];
      }
    );
  }

  addCampaign(formdata): void {
    this.apiService.post(this.apiConfig.addCampaign, JSON.stringify(formdata))
      .subscribe((res: any) => {
        console.log(res);
        this.getCampaignList();
        this.campaigns.push(formdata);
        this.toast.Success(res.body.data.message)
      }, err => {
        console.log(err);
      })
  }

  editCampaign(formdata): void {
    this.apiService.put(this.apiConfig.editCampaign + '?id=' + formdata.id, JSON.stringify(formdata))
      .subscribe((res: any) => {
        this.getCampaignList();
        this.toast.Success(res.data.message);
        let updateIndex = this.campaigns.findIndex(item => item.id == formdata.id);
        this.campaigns[updateIndex] = formdata;
      }, err => {
        console.log(err);
      })
  }

  deleteCampaign(formdata): void {
    this.apiService.put(this.apiConfig.editCampaign + '?id=' + formdata.id, JSON.stringify(formdata))
      .subscribe((res: any) => {
        this.toast.Success("Campaign Deleted");
        let updateIndex = this.campaigns.findIndex(item => item.id == formdata.id);
        this.campaigns.splice(updateIndex, 1);
      }, err => {
        console.log(err);
      })
  }

}
